import { session$ } from '@/features/auth/store'

// The current user's identity for the chat UI: used to align own vs. received
// messages and to resolve ownership affordances. Server stays authoritative;
// this is presentation only.
const useChatActor = () => {
	const session = session$.get()
	const user = session?.user
	return {
		id: user?.id ?? 'system',
		name: user?.fullName ?? 'Sistema',
	}
}

export { useChatActor }
